import ConfirmDialog from "./ConfirmDialog";

const CloseSessionDialog = ({
  open,
  handleClose,
  handleConfirm,
}) => {
  return (
    <ConfirmDialog
      open={open}
      handleClose={handleClose}
      handleConfirm={handleConfirm}
      title="Cerrar sesión"
      text="¿Desea cerrar sesión?"

    />
  );
};

export default CloseSessionDialog;
